import type React from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface TooltipLabelProps {
  label: React.ReactNode;
  description: React.ReactNode;
  className?: string;
}

export function TooltipLabel({ label, description, className }: TooltipLabelProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          className={cn(
            'tooltip-label-dots relative inline-flex min-w-0 cursor-help pb-[3px] leading-none',
            className,
          )}
        >
          {label}
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-[260px] text-xs leading-snug">
        {description}
      </TooltipContent>
    </Tooltip>
  );
}
